// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"557":"2ae1b70e","787":"6219249d"}[chunkId] + ".chunk.js";
};